// submitEmailToSupport.js
'use strict';
import { REPORT_EMAIL } from '../RemoteConfigKeys';
import env from '../resource/env.js';
import getUserAgent, {
  getIsInPwa,
  userAgentString,
} from '../resource/getUserAgent.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsCriticalChannel from '../resource/getIsCriticalChannel.js';

/**
 * Submit email
 * @kind action
 * @param {string} [{subject}] - email subject.
 * @param {string} [{body = ''}] - email body.
 * @return {Promise} Action promise.
 */
const submitEmailToSupport =
  ({
    subject,
    body = '',
    skipSubscribedChannel = false,
    skipNonCriticalChannel = false,
  } = {}) =>
  async (dispatch, getState) => {
    const ua = getUserAgent();
    const { name: browserName, version: browserVersion } = ua.browser;
    const { name: osName, version: osVersion } = ua.os;
    const isPWA = getIsInPwa();

    const state = getState();

    const targetEmail = getRemoteConfigData(state, REPORT_EMAIL);
    const username = getMeData(state, 'username');
    const pusherConnectionState = getOperationData(
      state,
      ['pusher', 'connection'],
      'state'
    );
    const pusherSubscribedStates = getOperationData(
      state,
      ['pusher'],
      'channels'
    );
    const version = env.TAG_NAME || env.BRANCH_NAME || 'local';
    const shaString = env.SHORT_SHA ? `(${env.SHORT_SHA})` : '';

    const defaultSubject = `${username} Bug Report`;
    let filteredPusherSubscribedStates = {};
    if (skipNonCriticalChannel) {
      Object.keys(pusherSubscribedStates)?.forEach(channelName => {
        if (getIsCriticalChannel({ channelName })) {
          filteredPusherSubscribedStates[channelName] =
            pusherSubscribedStates[channelName];
        }
      });
    } else {
      filteredPusherSubscribedStates = pusherSubscribedStates;
    }

    const pusherChannelStateBody = `
  ---

  SWAG Username: ${username},
  Source: ${location.href},
  Version: ${version}${shaString},
  Browser: ${browserName} ${browserVersion} ${isPWA ? 'PWA' : ''},
  OS: ${osName} ${osVersion},
  User Agent: ${userAgentString},
  Pusher Status: ${pusherConnectionState},
  Pusher Subscribe Channel:
  ${JSON.stringify(filteredPusherSubscribedStates, null, '\t')}`;

    const concatedBody = `${body}
  ${skipSubscribedChannel ? '' : pusherChannelStateBody}`;
    const url = new URL(
      `mailto:${targetEmail}?subject=SWAG webapp - ${
        subject || defaultSubject
      }&body=${encodeURIComponent(concatedBody)}`
    ).toString();

    if (isPWA) {
      location.href = url;
    } else {
      window.open(url);
    }
  };

export default submitEmailToSupport;
